export const SIGN_UP_URL = '/register/CA?payment_page_permalink=ca-trial-job';
export const LOG_IN_URL = '/login';
